import React from "react";
import parse from "html-react-parser";

const HeadingSection = ({ className = "", title }) => {
  return (
    <div className={`heading-section ${className}`}>
      <div className="container">
        <h2 className="heading-section__title">{parse(title)}</h2>
      </div>
    </div>
  );
};

export default HeadingSection;
